import React, { Component } from 'react';
import Cropper from 'react-easy-crop'
import './crop.css'
import AWS from "aws-sdk";
import { getawscredentials } from "../service";
import $ from "jquery";
// import Slider from '@material-ui/core/Slider'
var s3;
export default class CropInput extends Component {
    state = {
        imageSrc:this.props.cropImageUrl,       
        crop: { x: 0, y: 0 },
        zoom: 1,
        aspect: this.props.cropImageWidth / this.props.cropImageHeight,
        croppedAreaPixels: '',
        imgWidth: 0,
        imgHeight: 0,
        croppedImageUrl: '',
        fileName:''       
    }
    componentDidMount() {
        this.getAwsDetails();
        console.log('this.props.successInput......****************...', this.props.successInput)
        console.log('bucket...1...', window.sessionStorage.getItem('Bucket'))
        console.log('this.props.accessKey...2...', this.props.accessKey)
        console.log('this.props.secretKey...3...', this.props.secretKey)
        AWS.config.update({
            accessKeyId: this.props.accessKey,
            secretAccessKey: this.props.secretKey,
            region: "ap-south-1"
        });
        var bucketParams = {
            Bucket: window.sessionStorage.getItem('Bucket')
        };
        s3 = new AWS.S3({ apiVersion: "2006-03-01", params: bucketParams });
    }
    onMediaLoaded = image => {
        console.log('onMediaLoaded........', image)
        this.setState({
            imgWidth: image.width,
            imgHeight: image.height
        })
    };

    onCropChange = (crop) => {
        console.log('onCropChange........', crop)
        this.setState({ crop })
    }

    onCropComplete = (croppedArea, croppedAreaPixels) => {
        console.log('onCropComplete....croppedArea....', croppedArea)
        console.log('onCropComplete....croppedAreaPixels....', croppedAreaPixels)
        console.log(croppedArea, croppedAreaPixels)
        this.setState({ croppedAreaPixels: croppedAreaPixels })
    }

    onZoomChange = (zoom) => {
        console.log('onZoomChange........', zoom)
        this.setState({ zoom })
    }
    async confirmCrop() {
        console.log('confirmCrop........')
        const croppedImageUrl = await this.getCroppedImg(
            this.props.cropImageUrl,
            this.state.croppedAreaPixels,
            0
        )
        console.log('croppedImageUrl........', croppedImageUrl)
        this.setState({ croppedImageUrl }, () => {
            this.confirmBannerAddCrop();
            this.props.cropPopupClose()
            //this.props.cropDone(croppedImageUrl)
        });
        
    }
    // const createImage = url =>
    // new Promise((resolve, reject) => {
    //     const image = new Image()
    //     image.addEventListener('load', () => resolve(image))
    //     image.addEventListener('error', error => reject(error))
    //     image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
    //     image.src = url
    // })

    createImage = url =>
        new Promise((resolve, reject) => {
            const image = new Image()
            image.addEventListener('load', () => resolve(image))
            image.addEventListener('error', error => reject(error))
            image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
            image.src = url
        })

    async getCroppedImg(imageSrc, pixelCrop, rotation) {
        console.log('getCroppedImg........')
        console.log('pixelCrop........', pixelCrop)
        //  const image = imageSrc
        //const image = new Image()    
        const image = await this.createImage(imageSrc)
        //image.src = imageSrc
        //image.crossOrigin = "Anonymous";
        console.log('image.src........', image)
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        const maxSize = Math.max(image.width, image.height)
        const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2))
        console.log('maxSize........', maxSize)
        console.log('safeArea........', safeArea)
        // set each dimensions to double largest dimension to allow for a safe area for the
        // image to rotate in without being clipped by canvas context
        canvas.width = safeArea
        canvas.height = safeArea
        console.log(' canvas.width ........', canvas.width)
        // translate canvas context to a central location on image to allow rotating around the center.
        ctx.translate(safeArea / 2, safeArea / 2)
        //  ctx.rotate(getRadianAngle(rotation))
        ctx.translate(-safeArea / 2, -safeArea / 2)
        // draw rotated image and store data.
        ctx.drawImage(
            image,
            safeArea / 2 - image.width * 0.5,
            safeArea / 2 - image.height * 0.5
        )
        console.log('ctx........', ctx)
        const data = ctx.getImageData(0, 0, safeArea, safeArea)
        console.log('data........', data)
        // set canvas width to final desired crop size - this will clear existing context
        canvas.width = pixelCrop.width
        canvas.height = pixelCrop.height
        // paste generated rotate image with correct offsets for x,y crop values.
        ctx.putImageData(
            data,
            Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x),
            Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y)
        )
        console.log('canvas...', canvas)
        // As Base64 string
        // return canvas.toDataURL('image/jpeg');
        // As a blob
        return new Promise(resolve => {
            canvas.toBlob(file => {
                console.log('file.....', file)
                // blob.name = newFile;
                this.setState({
                    cropFile: file
                })
                resolve(URL.createObjectURL(file))
            }, 'image/jpg')
        })
    }


    getAwsDetails() {
        let postData = {
          "functionName": "awsCredentials",
        };
        getawscredentials(postData).then((data) => {
          console.log("decoded", data);
          if (data.data.success === "1") {
            var decoded = data.data.result.s3Details;
            localStorage.setItem("S3BucketMainFolder", decoded.mainFolder);
            localStorage.setItem("Bucket", decoded.s3bucket);
    
            AWS.config.update({
              accessKeyId: decoded.accessKey,
              secretAccessKey: decoded.secretKey,
              region: "ap-south-1",
            });
            var bucketParams = {
              Bucket: decoded.s3bucket,
            };
            s3 = new AWS.S3({ apiVersion: "2006-03-01", params: bucketParams });
    
            this.setState(
              {
                s3BucketMainFolder: decoded.mainFolder,
                accessKey: decoded.accessKey,
                secretKey: decoded.secretKey,
                s3bucket: decoded.s3bucket,
              },
              () => {
                // resolve(true);
              }
            );
          } else {
            console.log("error:home:getAwsDetails:", data.errorMessage);
          }
        });
        // });
      }



    confirmBannerAddCrop = () => {
        
        let str = this.state.croppedImageUrl
        var last = str.substring(str.lastIndexOf("/") + 1, str.length);
        let S3BucketMainFolder =this.state.s3BucketMainFolder;
        let fileName = 'lapa_' + last + '.jpg';
        let reader = new File([this.state.cropFile], fileName, {
            type: "image/jpg",
            lastModified: Date.now()
        });
        let fullFilePath = S3BucketMainFolder + "/" + fileName;
        console.log('fullFilePath...............', fullFilePath)
        s3.upload(
            {
                Key: fullFilePath,
                Body: reader,
                ACL: "public-read"
            },
            (err, data) => {
                if (err) {
                    console.log("gfgfygjf".err)
                    alert(
                        "There was an error upload your photo: ",
                        err.message
                    );
                    return null
                }    
                else{   
                    this.props.cropDone(fileName,this.props.fileOutput,this.props.fileId)
                    $("#"+this.props.successInput).show();
                    $("#"+this.props.successInput).attr('src',str);
                    // this.setState({
                    //     fileName: fileName
                    // },()=>{
                    //     this.props.cropDone(fileName)
                    // })
                }  
                // $('#'+this.props.inputId).attr('src', data.Location);
                // $('#'+this.props.inputId).val(fileName);   
                // $('#hid'+this.props.inputId).val(fileName);   
                   
            }
        )        
    }
    cancelCrop(){
        this.props.cropPopupClose(this.props.fileId)
    }    
    render() {
        return (
        <div id="cropMasterBannerDiv" >
            <div className="cropTitle">

                <div className="cropSave">
                    <span className="saveButton" onClick={(e) => { this.confirmCrop() }}>Confirm Crop</span>
                    <span className="cancelButton" onClick={(e) => { this.cancelCrop() }}>Cancel</span>
                </div>
            </div>
            <div className="cropDiv">
                <div className="cropImageSection"></div>
                <div className="App">
                    <div className="crop-container">
                        <Cropper
                            image={this.state.imageSrc}
                            crop={this.state.crop}
                            zoom={this.state.zoom}
                            aspect={this.state.aspect}
                            onMediaLoaded={this.onMediaLoaded}
                            onCropChange={this.onCropChange}
                            onCropComplete={this.onCropComplete}
                            onZoomChange={this.onZoomChange}
                        />
                    </div>
                </div>
            </div>
        </div>
        )
    }
}
